import SingleManufactureProduct from './SingleManufactureProduct';

export default SingleManufactureProduct;
